import { LOCAL_STORAGE_AMOUNT_KEY, R } from 'config/app';
import { MAX_LOAN_AMOUNT, MIN_LOAN_AMOUNT } from 'config/domain';
import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useSessionStorage } from 'usehooks-ts';
import getClosestDivisible from 'utils/getClosestDivisible';
import useLoanApplicationQuery from 'ui/hooks/useLoanApplicationQuery';

interface UseLoanAmount {
  loanAmount: number;
  setLoanAmount: (value: number) => void;
}

const useLoanAmount = (): UseLoanAmount => {
  const [loanAmount, setLoanAmount] = useSessionStorage(
    LOCAL_STORAGE_AMOUNT_KEY,
    0,
  );
  const loanApplicationQuery = useLoanApplicationQuery();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams({});
  const amountFromUrl = getClosestDivisible(
    Number.parseInt(searchParams.get('amount') as string),
    MIN_LOAN_AMOUNT,
    MAX_LOAN_AMOUNT,
  );

  const pathnameWithoutSlash = pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;

  useEffect(() => {
    if (pathnameWithoutSlash === R.FirstLoanRegister) {
      setLoanAmount(amountFromUrl);
    }
  }, [pathnameWithoutSlash, amountFromUrl]);

  useEffect(() => {
    if (
      loanApplicationQuery.status !== 'success' ||
      loanApplicationQuery.loanApplication?.amount === undefined ||
      loanApplicationQuery.loanApplication?.amount === loanAmount
    )
      return;

    setLoanAmount(loanApplicationQuery.loanApplication?.amount);
  }, [
    loanApplicationQuery.status,
    loanApplicationQuery.loanApplication?.amount,
  ]);

  return { loanAmount, setLoanAmount };
};

export default useLoanAmount;
